import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import { Login, Email } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const NavigationBar = () => {
  const navigate = useNavigate();

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <AppBar 
      position="fixed" 
      sx={{ 
        bgcolor: 'rgba(255, 255, 255, 0.98)',
        backdropFilter: 'blur(10px)',
        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
        borderBottom: '1px solid rgba(0,0,0,0.05)',
      }}
    >
      <Toolbar sx={{ justifyContent: 'space-between', py: 1.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            component="img"
            src="/logo.png"
            alt="Stratovai"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            sx={{
              height: '40px',
              width: 'auto',
              cursor: 'pointer',
            }}
          />
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              cursor: 'pointer',
              fontSize: '1.5rem',
            }}
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            Stratovai
          </Typography>
          
          <Typography
            variant="body2"
            sx={{
              color: '#6b7280',
              fontSize: '0.9rem',
              display: { xs: 'none', md: 'block' },
            }}
          >
            Intelligent QA & Product Platform
          </Typography>
        </Box>
        
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            variant="text"
            startIcon={<Email />}
            onClick={scrollToContact}
            aria-label="Scroll to contact section"
            sx={{
              color: '#667eea',
              fontWeight: 600,
              textTransform: 'none',
              '&:hover': {
                bgcolor: 'rgba(102, 126, 234, 0.05)',
              },
              '&:focus-visible': {
                outline: '3px solid #667eea',
                outlineOffset: '2px',
                bgcolor: 'rgba(102, 126, 234, 0.05)',
              }
            }}
          >
            Contact
          </Button>
          
          <Button
            variant="outlined"
            startIcon={<Login />}
            onClick={() => navigate('/login')}
            aria-label="Navigate to login page"
            sx={{
              borderColor: '#667eea',
              color: '#667eea',
              fontWeight: 600,
              textTransform: 'none',
              px: 3,
              '&:hover': {
                borderColor: '#5568d3',
                bgcolor: 'rgba(102, 126, 234, 0.05)',
              },
              '&:focus-visible': {
                outline: '3px solid #667eea',
                outlineOffset: '2px',
                borderColor: '#5568d3',
              }
            }}
          >
            Login
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default NavigationBar;

